import React, { useState } from "react";
import { Row, Col, Card, Button, InputNumber } from "antd";
import styled from "styled-components";
import { addZeroes } from "../../config/utils";
const ShippingCostWrapper = styled(Card)`
  min-height: 200px;
  .ant-card-body {
    padding: 0;
  }
  box-shadow: 0px 0px 5px 0px rgb(0 0 0 / 16%);
  padding: 10px;

  .shiping-cost {
    align-items: center;
    padding: 10px 15px;
    font-size: 16px;
  }
`;

export default function ShippingCost({
  onUpdateShippingCost,
  updateShippingCost,
  value,
  shipingprice,
}) {
  return (
    <Row justify="center">
      <Col xl={24} xs={24} sm={24} lg={24} md={24}>
        <ShippingCostWrapper>
          <Row justify="start">
            <Col xl={14}>
              <h5 className="text-left" style={{ padding: "5px 5px 10px 5px" }}>
              Expedite              </h5>
            </Col>
          </Row>
          <Row justify="space-between">
            <Col xl={10}>
              <p className="text-left shiping-cost">Yes</p>
            </Col>
            <Col xl={14}>
              <span className="shiping-cost">$</span>
              <InputNumber
                min={1}
                max={100000}
                onChange={(e) => onUpdateShippingCost(e, "am_charges")}
                name="am_charges"
                value={value.am_charges}
              />
            </Col>
          </Row>
          <Row justify="space-between">
            <Col xl={10}>
              <p className="text-left shiping-cost">No</p>
            </Col>
            <Col xl={14}>
              <span className="shiping-cost">$</span>
              <InputNumber
                min={1}
                max={100000}
                onChange={(e) => onUpdateShippingCost(e, "pm_charges")}
                name="pm_charges"
                value={`${value.pm_charges}`}
              />
            </Col>
          </Row>
          <Row justify="end">
            <Col>
              <Button
                style={{
                  backgroundColor: "#ff9800",
                  color: "#fff",
                  width: "100%",
                }}
                onClick={() => updateShippingCost(value, shipingprice.id)}
              >
                SAVE
              </Button>
            </Col>
          </Row>
        </ShippingCostWrapper>
      </Col>
    </Row>
  );
}
